/* src/app/components/controls/sem-bound-tab-control/sem-bound-tab-control.component.css */
/*# sourceMappingURL=sem-bound-tab-control.component.css.map */
